import { PreSaleBanner } from '../components/layout/PreSaleBanner';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { CookieConsent } from '../components/CookieConsent';
import { SEO } from '../components/SEO';
import { HeroSection } from '../components/home/HeroSection';
import { AudienceSection } from '../components/home/AudienceSection';
import { ProblemAnswerSection } from '../components/home/ProblemAnswerSection';
import { ProductIngredientsSection } from '../components/home/ProductIngredientsSection';
import { CleanLabelSection } from '../components/home/CleanLabelSection';
import { ScienceTeaserSection } from '../components/home/ScienceTeaserSection';
import { PriceTransparencySection } from '../components/home/PriceTransparencySection';
import { PricingSection } from '../components/home/PricingSection';
import { FAQSection } from '../components/home/FAQSection';
import { FlowBackground } from '../components/home/FlowBackground';

export default function Home() {
    return (
        <div>
            <SEO
                title="Sleepstack | Build Your Evening"
                description="No vague sleep claims. A transparent evening powder with 5 functional ingredients, visible dosages, no melatonin and no proprietary blends. Pre-order for €35."
                path="/"
            />
            <PreSaleBanner />
            <Navbar />
            <main>
                <div
                    className="relative isolate"
                    style={{ background: 'linear-gradient(to bottom, #FFFFFF 0%, #FDF6F9 35%, #FCF3F6 75%, #E9EFFB 100%)' }}
                    data-testid="glass-flow"
                >
                    <FlowBackground />
                    <HeroSection />
                    <AudienceSection />
                    <ProblemAnswerSection />
                </div>
                <ProductIngredientsSection />
                <div
                    className="relative isolate"
                    style={{ background: 'linear-gradient(to bottom, #F5EFE6 0%, #FDF6F9 8%, #FFFFFF 45%, #FCF3F6 80%, #FDF6F9 100%)' }}
                    data-testid="glass-flow-bottom"
                >
                    <FlowBackground variant="bottom" />
                    <CleanLabelSection />
                    <ScienceTeaserSection />
                    <PriceTransparencySection />
                    <PricingSection />
                    <FAQSection />
                </div>
            </main>
            <Footer />
            <CookieConsent />
        </div>
    );
}
